export const TWO_MB = 2 * 1024 * 1024
export const MAX_AVATAR_WIDTH = 1000
export const MAX_AVATAR_HEIGHT = 1000

export async function getImageDimensions(url: string): Promise<{
  width: number
  height: number
}> {
  const img = new Image()

  const promise = new Promise<{ width: number; height: number }>(
    (resolve, reject) => {
      img.onload = () => {
        const width = img.naturalWidth
        const height = img.naturalHeight
        resolve({ width, height })
      }

      img.onerror = () => {
        reject(new Error('Failed to load image'))
      }

      img.onabort = () => {
        reject(new Error('Image loading was aborted'))
      }
    },
  )

  img.src = url

  return promise
}

export async function validateFileDimensions(
  file: File,
  maxWidth?: number,
  maxHeight?: number,
): Promise<boolean> {
  const objectUrl = URL.createObjectURL(file)

  try {
    const { width, height } = await getImageDimensions(objectUrl)

    if (maxWidth && width > maxWidth) {
      return false
    }
    if (maxHeight && height > maxHeight) {
      return false
    }
    return true
  } catch {
    // If we can't get image dimensions (corrupted file, invalid format, etc.),
    // treat it as a validation failure
    return false
  } finally {
    // Clean up the object URL to prevent memory leaks
    URL.revokeObjectURL(objectUrl)
  }
}

export function validateFileSize(file: File, maxFileSize: number): boolean {
  if (file.size > maxFileSize) {
    return false
  }
  return true
}
